<template>
  <v-card
    tile
  >
    <v-toolbar :color="color" dense>
      <v-toolbar-title><div>{{$t("app.job.label", {jobId: job.description})}}<span class="body-2 pl-2">
        <em>{{ jobVerboseStatus }}</em>
      </span></div></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn 
        :disabled="readOnlyProject"
        v-if="job.status == 'STARTED'"
        @click="cancelJob(job.id)"
        icon
      >
        <v-icon>mdi-stop</v-icon>
      </v-btn>
      <v-btn 
        @click="show = !show"
        icon
      >
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text v-if="show">
      <v-container py-1>
        <v-layout column>
          <v-flex>
            <div>
              <span>
                <code>{{ job.statusMessage }}</code>
              </span>
            </div>
          </v-flex>
          <v-flex py-1 v-if="job.status == 'STARTED'">
            <v-progress-linear
              bottom
              reactive
              v-model="jobPercent"
              :active="job.status == 'STARTED'"
              rounded
              height="6"
            ></v-progress-linear>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card> 
</template>

<script>

import { localizedMoment } from "../api";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  props: ["job"],
  data() {
    return {
      show: false
    };
  },
  mounted: function () {
    this.show = this.job.status == "FAILED" || this.job.status == 'STARTED'
   },
  methods: {
    ...mapActions("jobs", ["fetchJobs", "cancelJob"])
  },
  computed: {
    ...mapGetters(["readOnlyProject"]),
    ...mapGetters("jobs", ["hasActiveJobs", "activeJobsCount"]),
    ...mapState("jobs", ["jobs"]),
    jobPercent() {
      return (100 * this.job.currentStepCount) / this.job.totalStepCount;
    },
    jobVerboseStatus() {
      return `${this.$i18n.t(`app.job.status.${this.job.status}`)} ${localizedMoment(
        this.job.status == "STARTED"  ? this.job.createdAt : this.job.completedAt
      ).fromNow()}`;
    },
    color() {
      if (this.job.status == "STARTED") {
        return "primary lighten-1";
      } else if (this.job.status == "PAUSED") {
        return "grey lighten-1";
      } else if (this.job.status == "CANCELLED") {
        return "warning lighten-1";
      } else if (this.job.status == "FAILED") {
        return "error lighten-1";
      } else if (this.job.status == "COMPLETED") {
        return "success lighten-1";
      } else {
        return "success lighten-1";
      }
    },
  }
};
</script>
